import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthLayoutComponent } from "src/app/components/auth-layout/auth-layout.component";
import { InputComponent } from "src/app/components/input/input.component";
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { AlertService } from 'src/app/services/alert.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    AuthLayoutComponent,
    InputComponent,
    TranslateModule,
    ReactiveFormsModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  private readonly fb = inject(FormBuilder);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly alertService = inject(AlertService);

  form: FormGroup = this.fb.group({
    login: ['', [Validators.required, Validators.email]],
    password: ['', Validators.required],
  });

  onSubmit() {
    this.form.markAllAsTouched();

    if (this.form.valid) {
      const body = this.form.value;

      this.authService.login(body).subscribe({
        next: (response) => {
          this.alertService.show({
            type: 'success',
            subtitle: 'LOGIN.SUCCESS'
          });

          this.authService.setStorage(response);
        },
        error: (error) => {
          this.alertService.show({
            type: 'error',
            subtitle: error.error.message
          });
        }
      });
    }
  }

  onForgotPassword() {
    const email = this.form.get('login')?.value;

    if (email) {
      this.router.navigateByUrl(`/auth/send-notification/${email}`);
    } else {
      this.router.navigateByUrl('/auth/send-notification');
    }
  }

  onMicrosoftLogin(): void {
    this.authService.loginMicrosoft();
  }
}
